import React from 'react';
import styled from '@emotion/styled';
import theme from '../design-system/theme';
import {centeredContent, centeredContentNoPadding, modularScale} from '../design-system/utils';
import ParagraphHeading from "../design-system/typography/paragraph-heading";
import StyledCopy from "../design-system/typography/copy";
import SiteDownloadButtons from "./site-download-buttons";

export default class SiteDownload extends React.PureComponent {

    render() {
        const {textResources, isIos, color} = this.props;

        return (
            <StyledSiteDownload>
                <div>
                    <ParagraphHeading>{textResources["title"]}</ParagraphHeading>
                    <StyledCopy big={true}>{textResources["copy"]}</StyledCopy>
                    <div className="downloadLayer">
                        <SiteDownloadButtons
                            color={color}
                            isIos={isIos}
                            textResources={textResources}/>
                    </div>
                    <ParagraphHeading
                        className="questionsHeadline">{textResources["questions_title"]}</ParagraphHeading>
                    <StyledCopy big={true} dangerouslySetInnerHTML={{__html: textResources["questions_copy"]}}/>
                </div>
            </StyledSiteDownload>
        );
    }
}

const StyledSiteDownload = styled('div')`
    ${centeredContent};
    padding-bottom: 40px;
    
    > div {
        ${centeredContentNoPadding};
        
        @media (min-width: ${theme.breakpoints.tablet}px) {
            max-width: 66%;
        }
    }
        
    > div > div {
        text-align: center;
        padding-top: 0px;
    }
    
    .questionsHeadline {
        padding-top: 50px;
    }
    
    .downloadLayer {
        padding-top: ${theme.dimensions.gridGap};
        padding-bottom: 0;
        width: 100%;
        margin: 0 auto;
        
        @media (min-width: ${theme.breakpoints.tablet}px) {
	        width: 80%;
        }
    
        @media (min-width: ${theme.breakpoints.desktop}px) {
	        width: 62%;
	    }
    }
`;